import React from 'react';

const ThankYouPage = () => {
  return (
    <div style={{minHeight:'100vh',background:'var(--surface-200)',display:'flex',alignItems:'center',justifyContent:'center',padding:'48px 24px'}}>
      <div style={{textAlign:'center',maxWidth:'480px'}}>
        <p style={{fontFamily:'var(--font-mono)',fontSize:'0.6875rem',textTransform:'uppercase',letterSpacing:'0.1em',color:'var(--text-tertiary)',margin:'0 0 16px'}}>Next Level Websites</p>
        <h1 style={{fontFamily:'var(--font-display)',fontSize:'clamp(2.5rem,6vw,4rem)',fontWeight:700,letterSpacing:'-2px',color:'var(--text-primary)',margin:'0 0 16px',lineHeight:1.05}}>Thank you.</h1>
        <p style={{fontFamily:'var(--font-body)',fontSize:'1.0625rem',color:'var(--text-secondary)',lineHeight:1.7,margin:'0 0 32px'}}>Your request has been received. We'll review it and get back to you within 24 hours.</p>
        <a href="/" style={{display:'inline-block',background:'var(--accent)',color:'#fff',borderRadius:'var(--radius-sm)',padding:'12px 28px',fontFamily:'var(--font-ui)',fontSize:'0.9375rem',fontWeight:600,textDecoration:'none',transition:'background 0.15s'}}>
          Back to Home
        </a>
      </div>
    </div>
  );
};

export default ThankYouPage;
